








import {defineComponent} from "@vue/composition-api"

import CreateRoomForm from "@/home/CreateRoomForm.vue"
import RoomsList from "@/home/RoomsList.vue"
import CodeOfConduct from "@/home/CodeOfConduct.vue"
import HomeHeader from "@/home/HomeHeader.vue"

export default defineComponent({
  name: 'HomePage',
  components: {HomeHeader, CodeOfConduct, RoomsList, CreateRoomForm}
})

